export default "__VITE_ASSET__BIXbAPi8__"